<template>
  <dd-drawer
    width="1200"
    v-if="dossier"
    @ok="visible = false"
    :closable="false"
    :cancelText="null"
    :visible="visible"
    @close="visible = false"
    :title="'Informatie Aanvraag aan ' + dossier.receiver_company_name"
  >
    <dd-loading-indicator size="sm" v-if="loading" />
    <dd-collapse v-if="dossier && !loading" accordion @change="viewRecord">
      <a-collapse-panel v-for="record in records" :key="record.id">
        <div class="flex-row justify-content-between" slot="header">
          <div class="flex-row gap-xs" style="overflow: hidden">
            <a-tag color="green" v-if="record.viewed_at === null">nieuw</a-tag>
            <h3 class="m-0" style="white-space: nowrap">
              {{ record.message_type }}
            </h3>
            <p
              style="
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                margin: 0;
              "
            >
              <a-tooltip :title="record.remark">
                {{ record.remark }}
              </a-tooltip>
            </p>
          </div>
          <div style="text-align: right; min-width: 150px">
            {{
              record.hdn_creation_date
                | toDate(DateFormatEnum.DISPLAY_DATETIME_WITH_SECONDS)
            }}
          </div>
        </div>
        <div class="flex-col">
          <div>
            <h3>Algemene informatie</h3>
            <dd-card-stacked-list>
              <dd-card-list-row>
                <dd-card-list-item title="Bericht type">
                  {{ record.message_type }}
                </dd-card-list-item>
                <dd-card-list-item title="Verstuurd op">
                  {{
                    record.hdn_creation_date
                      | toDate(DateFormatEnum.DISPLAY_DATETIME_WITH_SECONDS)
                  }}
                </dd-card-list-item>
                <dd-card-list-item title="Verwerkt op" v-if="record.message_type === HDNMessageTypeEnum.IX">
                  <span v-if="record.processed_at">
                    {{
                      record.processed_at
                        | toDate(DateFormatEnum.DISPLAY_DATETIME_WITH_SECONDS)
                    }}
                  </span>
                  <span v-else> Nog niet verwerkt. </span>
                </dd-card-list-item>
              </dd-card-list-row>
              <dd-card-list-row>
                <dd-card-list-item title="Opmerking">
                  {{ record.remark }}
                </dd-card-list-item>
              </dd-card-list-row>
            </dd-card-stacked-list>
          </div>
          <div>
            <h3>Acties</h3>
            <p v-if="record.message_type !== HDNMessageTypeEnum.IX">
              Er zijn geen acties voor dit bericht type.
            </p>
            <dd-button
              @click="processRecord(record)"
              v-else-if="processSuccessForRecord !== record.id"
            >
              Verwerk
            </dd-button>
            <span v-if="processLoading === record.id">
              Bericht verwerken...
            </span>
            <h4
              v-if="processSuccessForRecord === record.id"
              class="text-success"
            >
              Het bericht is verwerkt
            </h4>
            <h4 v-if="processFailedForRecord === record.id" class="text-danger">
              Het bericht is niet verwerkt, er ging iets mis.
            </h4>
          </div>
          <div>
            <h3>Inhoud</h3>
            <HDNMessageComponent
              v-if="record.hasOwnProperty('xmlMessage')"
              :message="record.xmlMessage.data.json"
            ></HDNMessageComponent>
          </div>
        </div>
      </a-collapse-panel>
    </dd-collapse>
  </dd-drawer>
</template>

<script>
import { HDNMessageTypeEnum } from "~/enums";
import DateFormatEnum from "../../enums/DateFormatEnum";
import HDNDossiersApi from "~/api/hdn_dossiers";
import moment from "moment";
import EmailAccountBadgeComponent from "~/modules/email_account/components/BadgeComponent.vue";
import HDNMessageComponent from "./HDNMessageComponent.vue";

export default {
  components: { EmailAccountBadgeComponent, HDNMessageComponent },
  data() {
    return {
      loading: false,
      HDNMessageTypeEnum,
      dossier: null,
      showXML: null,
      processLoading: null,
      viewLoading: null,
      processSuccessForRecord: null,
      processFailedForRecord: null,
      processRemarks: null,
      visible: false,
      records: null,
    };
  },
  methods: {
    async getRecords() {
      this.loading = true;
      let response = await HDNDossiersApi.getRecords(this.dossier.id);

      this.records = response.data;
      this.loading = false;
    },
    async viewRecord(recordId) {
      if (!recordId) {
        return;
      }

      let index = this.records.findIndex((record) => record.id === recordId);

      if (this.records[index].hasOwnProperty("xmlMessage")) {
        return;
      }

      this.viewLoading = recordId;
      let response = await HDNDossiersApi.getRecord(recordId);

      this.viewLoading = null;

      if (index !== -1) {
        this.$set(this.records, index, response.data); // Use Vue's reactive methods
      } else {
        console.error("Record not found");
      }

      this.$set(
        this.dossier,
        "unviewed_records_count",
        this.records.filter((record) => record.viewed_at === null).length
      );
    },
    viewDossier(dossier) {
      this.dossier = dossier;
      this.getRecords();
      this.visible = true;
    },
    async processRecord(record) {
      this.processLoading = record.id;
      this.showXML = false;
      try {
        let response = await HDNDossiersApi.processRecord(record.id);

        record.processed_at = moment();
        this.processSuccessForRecord = record.id;
        this.processRemarks = response.remarks;
        location.reload();
      } catch (error) {
        this.processFailedForRecord = record.id;
      } finally {
        this.processLoading = null;
        this.loading = false;
      }
    },
  },
  computed: {
    DateFormatEnum() {
      return DateFormatEnum;
    },
  },
};
</script>
